import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const ExpenseSheetSkeleton: React.FC = () => (
  <div className="mt-4 space-y-3">
    <Skeleton className="h-6 w-48" />
    {Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-4 w-full" />)}
    <Skeleton className="h-24 w-full" />
  </div>
)
export default ExpenseSheetSkeleton
